import { render, staticRenderFns } from "./workflow-display.vue?vue&type=template&id=6be0d567&scoped=true&"
import script from "./workflow-display.vue?vue&type=script&lang=js&"
export * from "./workflow-display.vue?vue&type=script&lang=js&"
import style0 from "./workflow-display.vue?vue&type=style&index=0&id=6be0d567&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be0d567",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VBtn,VIcon})
